import Backbone from 'backbone'

const TimesTableOrderView = Backbone.View.extend({
    tagName: 'li',
    className: 'f3_menu_choices_buttons',
    events: {
        'click': 'chooseOrder',
    },
    initialize(options) {
        this.in_order = options.in_order
    },
    render() {
        if (this.in_order) {
            this.$el.html('In Order')
        } else {
            this.$el.html('Random')
        }

        return this
    },
    chooseOrder() {
        this.model.set({
            state: 'game',
            in_order: this.in_order
        })
    }
})

export default TimesTableOrderView
